import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserLoginType } from 'client/types';

type Login = {
  loginFormType: UserLoginType;
};

const initialState: Login = {
  loginFormType: UserLoginType.none,
};

export const Login = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setFormByUserType: (state, action: PayloadAction<UserLoginType>) => {
      state.loginFormType = action.payload;
    },
  },
});

export const { setFormByUserType } = Login.actions;
export default Login.reducer;
